import axios from "axios";
import Config from "../utils/Config";

class RestRequestApprovalService {
    config = {
        headers: {
          Authorization: "",
          CompanyId: "",
        },
    };

    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
      }

    async createTemplate(formData) {
        console.log(formData,"Template fordata");
        const data = await axios.post(
            Config.BACKEND_URL + "/api/template/",
            formData,
            this.config
        )
        return data.data;
    }
    async editTemplate(formData,templateId) {
        console.log(formData,"Template fordata");
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/template/${templateId}`,
            formData,
            this.config
        )
        return data.data;
    }
    async getTemplates(){
        console.log(this.config,"getTemplates configuration");
        const data = await axios.get(
            Config.BACKEND_URL + "/api/template/",
            this.config
        )
        console.log(data.data,"getTemplates");
        return data.data;
    }

    async getRequestTypes(){
        // console.log(this.config,"getTemplates configuration");
        const data = await axios.get(
            Config.BACKEND_URL + "/api/approvalRequest/requestTypes",
            this.config
        )
        // console.log(data.data,"getRequestTypes");
        return data.data;
    }

    async getBranches(){
        // console.log(this.config,"getTemplates configuration");
        const data = await axios.get(
            Config.BACKEND_URL + "/api/branch",
            this.config
        )
        // console.log(data.data,"getRequestTypes");
        return data.data;
    }

    async getTeamsForCompany(){
        // console.log(this.config,"getTemplates configuration");
        const data = await axios.get(
            Config.BACKEND_URL + "/api/team/",
            this.config
        )
        // console.log(data.data,"getRequestTypes");
        return data.data;
    }
    async getAddHocUsers(id){
        // console.log(this.config,"getTemplates configuration");
        const data = await axios.get(
            Config.BACKEND_URL + `/api/signatories/userId/${id}`,
            this.config
        )
        // console.log(data.data,"getRequestTypes");
        return data.data;
    }

    async usersByCompanyId(){
        // console.log(this.config,"getTemplates configuration");
        const data = await axios.get(
            Config.BACKEND_URL + `/api/userDetails/usersByCompanyId`,
            this.config
        )
        // console.log(data.data,"getRequestTypes");
        return data.data;
    }

    async createTeam(formData){
        // console.log(this.config,"getTemplates configuration");
        const data = await axios.post(
            Config.BACKEND_URL + "/api/team/",
            formData,
            this.config
        )
        return data.data;
    }
    async editTeam(formData,companyid){
        // console.log(formData,"getTemplates configuration");
        // console.log(companyid,"getTemplates configuration");

        const data = await axios.patch(
            Config.BACKEND_URL + `/api/team/${companyid}`,
            formData,
            this.config
        )
        return data.data;
    }

    async saveRequestApproval(requestAprovalObj){
        // console.log(formData,"getTemplates configuration");
        // console.log(companyid,"getTemplates configuration");

        const data = await axios.post(
            Config.BACKEND_URL + `/api/approvalRequest/`,
            requestAprovalObj,
            this.config
        )
        return data.data;
    }
    async updateRequestApproval(requestAprovalObj,id){
        // console.log(formData,"getTemplates configuration");
        // console.log(companyid,"getTemplates configuration");

        const data = await axios.patch(
            Config.BACKEND_URL + `/api/approvalRequest/${id}`,
            requestAprovalObj,
            this.config
        )
        return data.data;
    }

    async saveSuportDocuments(formdata){
        // console.log(formData,"getTemplates configuration");
        // console.log(companyid,"getTemplates configuration");

        const data = await axios.post(
            Config.BACKEND_URL + `/api/approvalRequest/uploadDocuments`,
            formdata,
            this.config
        )
        return data.data;
    }

    async removeSuportDocuments(approvalRequestId,documentId){

        const data = await axios.delete(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}/deleteDocument/${documentId}`,
            this.config
        )
        return data.data;
    }

    async renameSuportDocuments(payload){
        console.log(this.config,"renameSuportDocuments token")
        const data = await axios.put(
            Config.BACKEND_URL + `/api/approvalRequest/renameDocument`,
            payload,
            this.config
        )
        return data.data;
    }

    async gettemplateById(id){
        console.log(this.config,"renameSuportDocuments token")
        const data = await axios.get(
            Config.BACKEND_URL + `/api/template/${id}`,
            this.config
        )
        return data.data;
    }
    async deletetemplateById(id){
        console.log(this.config,"renameSuportDocuments token")
        const data = await axios.delete(
            Config.BACKEND_URL + `/api/template/${id}`,
            this.config
        )
        return data.data;
    }
    async deleteTeamById(id){
        console.log(this.config,"renameSuportDocuments token")
        const data = await axios.delete(
            Config.BACKEND_URL + `/api/team/${id}`,
            this.config
        )
        return data.data;
    }

    async testWithJWTandCID (companyId, accessToken){
        
        this.setAccessToken(accessToken, companyId);
    
        //console.log(this.config);
    
      }
}

export default new RestRequestApprovalService();